import axios from 'axios';

import { applications, parserUtils } from 'z-js-commons';

import { API_URL } from '../config';
import * as types from '../constants/ActionTypes';
import { handleUnauthorizedError } from '../lib/heartBeat';

export function getEditorialHomeworkList(ids, searchTerm, isSuggestionSelected, taxonomyPathString, filters, userId, favouriteOnly = false, searchPage = 0) {
    searchPage++;
    const url = `${API_URL}/cv/homework/editorial`;
    return async dispatch => {
        dispatch({
            type: searchPage === 1 ? types.SEARCH_EDITORIAL_HOMEWORK : types.SEARCH_MORE_EDITORIAL_HOMEWORK,
            payload: {
                searchIdsList: ids,
                searchTerm,
                isSuggestionSelected,
                taxonomyPathString,
                favouriteOnly,
                filters,
                page: searchPage
            }
        });
        try {
            if (!filters) {
                filters = {
                    books: [],
                    authors: [],
                    subjects: [],
                    itemTypes: []
                };
            }
            const { books, authors, subjects } = filters;
            const {
                data: { data, totalCount }
            } = await axios.post(url, {
                contentPath: ids,
                favourite: favouriteOnly,
                page: searchPage,
                books: Array.isArray(books) && books.length > 0 ? parserUtils.getElementsFromArrayByProp('ids', books) : undefined,
                authors: Array.isArray(authors) && authors.length > 0 ? parserUtils.getElementsFromArrayByProp('id', authors) : undefined,
                subjects: Array.isArray(subjects) && subjects.length > 0 ? parserUtils.getElementsFromArrayByProp('ids', subjects) : undefined,
                origin: applications.CREA_VERIFICHE
            });

            dispatch({
                type: searchPage === 1 ? types.SEARCH_EDITORIAL_HOMEWORK_SUCCESS : types.SEARCH_MORE_EDITORIAL_HOMEWORK_SUCCESS,
                payload: {
                    result: data,
                    totalCount,
                    searchPage
                }
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: searchPage === 1 ? types.SEARCH_EDITORIAL_HOMEWORK_FAILURE : types.SEARCH_MORE_EDITORIAL_HOMEWORK_FAILURE,
                error: e
            });
        }
    };
}

export function handleEditorialHomeworksFiltersChange(filters, searchIdList, searchTerm) {
    return dispatch => {
        dispatch({
            type: types.HOMEWORKS_EDITORIAL_FILTERS_CHANGE,
            payload: {
                searchIdList: searchIdList,
                searchTerm: searchTerm,
                filters: filters
            }
        });
    };
}
